<template>
	<div class="nn-profile-form-shell">
		<form
			id="password-form"
			ref="passwordForm"
			class="nn-profile-form nn-profile-form--narrow"
			enctype="multipart/form-data"
			accept-charset="UTF-8"
			:aria-busy="loading"
			@submit.prevent="submitForm"
		>
			<input type="hidden" :name="csrfName" :value="csrfToken">
			<input type="hidden" name="action" value="users/save-user">
			<input type="hidden" name="userId" :value="currentUser.id">

			<div class="nn-profile-form__grid nn-profile-form__grid--single">
				<div class="nn-profile-form__field">
					<label class="uk-form-label" for="profile-current-password">Huidig wachtwoord</label>
					<input
						id="profile-current-password"
						v-model="password"
						type="password"
						class="uk-input"
						name="password"
						placeholder="Huidig wachtwoord"
						autocomplete="current-password"
						required
					>
				</div>

				<div class="nn-profile-form__field">
					<label class="uk-form-label" for="profile-new-password">Nieuw wachtwoord</label>
					<input
						id="profile-new-password"
						v-model="newPassword"
						type="password"
						class="uk-input"
						name="newPassword"
						placeholder="Nieuw wachtwoord"
						autocomplete="new-password"
						required
					>
				</div>

				<div class="nn-profile-form__field">
					<label class="uk-form-label" for="profile-confirm-password">Herhaal nieuw wachtwoord</label>
					<input
						id="profile-confirm-password"
						v-model="newPasswordConfirm"
						type="password"
						class="uk-input"
						name="newPasswordConfirm"
						placeholder="Herhaal nieuw wachtwoord"
						autocomplete="new-password"
						required
					>
				</div>
			</div>

			<div class="nn-profile-form__actions">
				<button class="uk-button uk-button-primary" type="submit" :disabled="loading">
					Wachtwoord wijzigen
				</button>
			</div>

			<div
				v-show="overlay"
				class="nn-profile-feedback"
				:class="{ 'is-error': error, 'is-success': success }"
				:role="error ? 'alert' : 'status'"
				:aria-live="error ? 'assertive' : 'polite'"
			>
				<loading-indicator v-if="loading"></loading-indicator>
				<span v-else-if="error" class="material-symbols-outlined" aria-hidden="true">error</span>
				<span v-else-if="success" class="material-symbols-outlined" aria-hidden="true">done</span>
				<p v-if="message" v-text="message"></p>
			</div>
		</form>
	</div>
</template>

<script>
import axios from 'axios';
import LoadingIndicator from './LoadingIndicator.vue'

export default {
	name: 'PasswordForm',
	components: { LoadingIndicator },
	props: {
		currentUser: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			overlay: false,
			error: false,
			success: false,
			loading: false,
			message: '',
			password: '',
			newPassword: '',
			newPasswordConfirm: '',
		};
	},
	computed: {
		csrfName() {
			return window.csrfTokenName
		},
		csrfToken() {
			return window.csrfTokenValue
		},
	},
	methods: {
		responseErrorMessage(data = {}) {
			const messages = [];

			if (data.error) {
				messages.push(data.error);
			}

			if (data.errors) {
				Object.values(data.errors).forEach((fieldErrors) => {
					if (Array.isArray(fieldErrors)) {
						messages.push(...fieldErrors);
					}
				});
			}

			return messages.join('\n');
		},
		showError(message) {
			this.overlay = true;
			this.loading = false;
			this.error = true;
			this.success = false;
			this.message = message || 'Onbekende fout, probeer het opnieuw.';
			window.setTimeout(this.resetMessage, 5000);
		},
		submitForm(event) {
			if (this.newPassword !== this.newPasswordConfirm) {
				this.showError('De nieuwe wachtwoorden komen niet overeen.');
				return;
			}

			const formData = new FormData(event.target);

			this.overlay = true;
			this.loading = true;
			this.error = false;
			this.success = false;
			this.message = '';

			axios({
				method: 'post',
				url: '/actions/users/save-user',
				responseType: 'json',
				data: formData,
				headers: {
					'Accept': 'application/json'
				}
			})
			.then((response) => {
				const errorMessage = this.responseErrorMessage(response.data);

				if (errorMessage) {
					this.showError(errorMessage);
					return;
				}

				this.loading = false;
				this.success = true;
				this.message = 'Wachtwoord bijgewerkt.';
				this.password = '';
				this.newPassword = '';
				this.newPasswordConfirm = '';
				window.setTimeout(this.resetMessage, 2200);
			})
			.catch((requestError) => {
				const responseData = requestError.response?.data || {};
				this.showError(this.responseErrorMessage(responseData) || responseData.message);
			});
		},
		resetMessage() {
			this.message = '';
			this.error = false;
			this.success = false;
			this.overlay = false;
			this.loading = false;
		}
	},
};
</script>
